module.exports = __webpack_public_path__ + "img/live_text.d1dc6df.png";